import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { VirksomhedDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/virksomhed-dto';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { InstallatoerService, VirksomhedService } from 'src/app/api/services';
import { InstallatoerDialogData } from 'src/app/components/aftale/models';
import { InstallatoerDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/installatoer-dto';
import { InstallatoerRequest } from 'src/app/api/models/OK/Egis/Service/Models/Request/installatoer-request';
import { NotificationService } from 'src/app/notifications/services/notification.service';

@Component({
    selector: 'app-installatoer-dialog',
    templateUrl: './installatoer-dialog.component.html',
    styleUrls: ['./installatoer-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InstallatoerDialogComponent implements OnInit {
  installatoer: InstallatoerDto;
  virksomhed: VirksomhedDto;
  form: UntypedFormGroup;
  unsubscribe$ = new Subject<void>();

  get cvr() {
    return this.form?.get('cvr');
  }

  get name() {
    return this.form?.get('name');
  }

  constructor(
    private virksomhedService: VirksomhedService,
    private installatoerService: InstallatoerService,
    private formBuilder: UntypedFormBuilder,
    private errorHandler: ErrorHandlerService,
    private notifications: NotificationService,
    public dialogRef: MatDialogRef<InstallatoerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InstallatoerDialogData
  ) {
    this.installatoer = data.installatoer;
    this.form = this.formBuilder.group({
      cvr: ['', [Validators.required, Validators.minLength(8)]],
      name: ['', [Validators.required, Validators.minLength(3)]],
    });
  }

  ngOnInit(): void {
    if (this.data.id) {
      this.cvr.setValue(this.data.cvr);
      this.name.setValue(this.data.name);
    }
    if (this.data.searchQuery) {
      this.virksomhedService
        .searchVirksomhed({
          caller: EGIS_SERVICE_CALLER,
          searchQuery: this.data.searchQuery,
        })
        .pipe()
        .subscribe(
          (response: VirksomhedDto) => {
            this.virksomhed = response;
            if (response) {
              this.cvr.setValue(response.cvr);
              this.name.setValue(response.name);
            } else {
              this.cvr.setValue(this.data.searchQuery);
              this.name.setValue(this.data.searchQuery);
            }
          },
          (error) => {
            this.errorHandler.HandleError(error);
          }
        );
    }
  }

  add() {
    const request: InstallatoerRequest = {
      cvr: this.cvr.value,
      name: this.name.value,
    };
    this.installatoerService
      .addInstallatoer({
        caller: EGIS_SERVICE_CALLER,
        body: request,
      })
      .pipe()
      .subscribe(
        (r) => {
          this.notifications.success(`Installatøer med cvr: ${r.cvr} er oprettet`);
          this.dialogRef.close(r);
        },
        (error) => {
          this.errorHandler.HandleError(error);
        }
      );
  }

  cancel() {
    this.dialogRef.close();
  }

  update() {
    this.installatoerService
      .updateInstallatoer({
        caller: EGIS_SERVICE_CALLER,
        body: {
          id: this.installatoer.id,
          cvr: this.cvr.value,
          name: this.name.value,
        },
      })
      .pipe()
      .subscribe(
        (r) => {
          this.notifications.success(`Installatøer med cvr: ${r.cvr} er opdateret`);
          this.dialogRef.close(r);
        },
        (error) => {
          this.errorHandler.HandleError(error);
        }
      );
  }

  searchByCvr() {
    if (this.cvr.value)
      this.virksomhedService.searchVirksomhed({ searchQuery: this.cvr.value, caller: EGIS_SERVICE_CALLER }).subscribe((p) => {
        if (p) {
          this.name.setValue(p.name);
          this.cvr.setValue(p.cvr);
        } else {
          this.notifications.warning(`Virksomhed med cvr: ${this.cvr.value} kan ikke findes`);
        }
      });
  }

  onCvrKeyDownEvent(event: KeyboardEvent) {
    if (event.key == 'Enter' && this.cvr.valid && !this.name.value) this.searchByCvr();
  }
}
